import { IAPIResponse } from "../interfaces/api";
import { IElementKindInfo, IElementPeriodInfo, IElementAPIPropertiesResponse, IElementScopeInfo } from "../interfaces/elements";
import { config } from "../utils/config";
import { log } from "../utils/logger";
import { formatURL } from "../utils/utils";

export const getElementsList = async <Type>(lanid: string): Promise<IAPIResponse<Array<Type>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/elements?userName=${lanid}`;
    const headers = new Headers();

    log.debug(`getElementsList HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const getElementProperties = async (): Promise<IAPIResponse<IElementAPIPropertiesResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/elements/properties`;
    const headers = new Headers();

    log.debug(`getElementProperties HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const getPeriodInfo = async (): Promise<IAPIResponse<Array<IElementPeriodInfo>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/elements/period`;
    const headers = new Headers();

    log.debug(`getPeriodInfo HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const getKindInfo = async (): Promise<IAPIResponse<Array<IElementKindInfo>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/elements/kind`;
    const headers = new Headers();

    log.debug(`getKindInfo HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const getScopeInfo = async (): Promise<IAPIResponse<Array<IElementScopeInfo>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/elements/scope`;
    const headers = new Headers();

    log.debug(`getScopeInfo HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}